<template>
  <div class='editPersoninfoDialog'>
    <van-popup class="dialog-cont" v-model="flag" :close-on-click-overlay="false">
      <div class="cont">
        <div class="tips">
          {{content}}
        </div>
        <span class="icon" @click="close">
          <van-icon name="close" color="#6666" size="0.16rem" />
        </span>
        <div class="btn">
          <button class="left" @click="junmp('xiaozi')">我有疑问，联系客服</button>
          <button class="right" @click="junmp('login')">去登录</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { motorCodeObj } from '@/utils/const'
export default {
  props:{
    flag:{
      type: Boolean,
      default: false,
      required: true
    },
    content:{
      type: String,
      default: "",
      required: true
    },
    originalPhone:{
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    close() {
      this.$emit("close-dialog")
    },
    junmp(tup) {
      if( tup === 'xiaozi') {
        window.location.href = "https://open.zking.com/app/mall/robot-support/#/blank"
      } else {
        window.location.href = process.env.API_HOST + motorCodeObj[localStorage.getItem('setMotorCode')]
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.editPersoninfoDialog {
  .dialog-cont {
    /deep/.van-popup--center {
      border-radius: 0.08rem;
    }
    .cont {
      width: 3.3rem;
      position: relative;
      text-align: center;
      font-size: 0.14rem;
      color: #333333;
      background: #ffffff;
      .tips {
        padding: 0.3rem 0.2rem;
        box-sizing: border-box;
      }
      .icon{
        position: absolute;
        right: 0.08rem;
        top: 0.08rem;
      }
      .btn {
        display: flex;
        button {
          padding: 0.1rem;
          box-sizing: border-box;
          flex: 1;
          // font-size: 0.16rem;
          background: #ffffff;
          border-radius: 0;
          border-bottom: none;
          border-left: none;
          border-top: 1px solid #e7e7e7;
        }
        .left {
          color: #999999;
          border-right: 1px solid #e7e7e7;
        }
        .right {
          color: #5f2689;
          border-right: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editPersoninfoDialog/editPersoninfoDialog.vue